<template>
  <div v-if="item.editorType == 'ParentSelectBox'">
    <div class="select-box-row">
      <DxSelectBox class="select-box" :items="DD_List" :value="selectedList" @value-changed="onDropdownListChange" display-expr="name"
        value-expr="id" />
    </div>
  </div>
  <div v-if="item.editorType == 'dependentSelectBox'">
    <div class="select-box-row">
      <DxSelectBox class="select-box" :items="selectedListOptions" :value="selectedDefaultList" @value-changed="onDefaultListChange"
        display-expr="name" value-expr="name" placeholder="Select an option" />
    </div>
  </div>  
</template>

<script>
import { DxSelectBox } from "devextreme-vue/select-box";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    DxSelectBox,
  },
  data: function () {
    return {
      selectedList: null,
      selectedListOptions: [],
      selectedDefaultList: null,
      DD_List: [],
    };
  },
  methods: {
    onDropdownListChange(e) {
      this.selectedList = e.value;
   
      const selectedItem = this.DD_List.find(item => item.id === this.selectedList);
      

      if (selectedItem) {
        this.selectedListOptions = selectedItem.options;
        this.selectedDefaultList = null;
      } else {
        console.log("No matching item found for:", this.selectedList);
        this.selectedListOptions = [];
        this.selectedDefaultList = null;
      }

      console.log("Default List Options:", this.selectedListOptions,this.item);
      // Emit both values to parent as an object
      this.emitValues();
    },

    onDefaultListChange(e) {
      this.selectedDefaultList = e.value;
      console.log("Selected Default List:", e);

      // Emit both values to parent as an object
      this.emitValues();
    },

    emitValues() {
      // Create a data object with both values
      const selectionData = {
        dropdownList: this.selectedList,
        defaultList: this.selectedDefaultList
      };

      // Emit to parent component
      this.$emit('update:value', selectionData);
    },

    getDDList() {
      this.errors = {};
      axios
        .get("/dropdown/list")
        .then((response) => {
          this.DD_List = response.data.results.data;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
  },
  mounted() {
    this.getDDList();
    console.log("mounted", this.item);
  }
};
</script>

<style>
.select-box-row {
  display: flex;
    gap: 16px;   
    align-items: center;
    width: 100%;
}

.select-box {
    flex: 1;    
}
</style>